import React from "react";
import { connect } from "react-redux";
import { Field, InjectedFormProps, reduxForm } from "redux-form";
import { Form, Message, Modal } from "semantic-ui-react";
import CustomLoader from "../common/CustomLoader";
import NumberInput from "../forms/NumberInput";

type AddStartProjectsModalProps = {
  /** Modal state. True == open .*/
  openModal: boolean;
  /** Function to run on modal close. */
  onModalClose: () => any;
  /** Function to call when submitting form. */
  onSubmit: (values: any) => void;
  /** Reflects onSubmit form error state. This works nice with fathers' Redux state management. */
  formSubmitFailed: boolean;
  /** Message to show on onSubmit error. */
  formSubmitFailedMessage: string;
  /** Should the form display Loading component. */
  isLoading: boolean;
};

/**
 * Modal with form for allowing user to add Start Projects to the account.
 */
class AddStartProjectsModal extends React.PureComponent<
  AddStartProjectsModalProps & InjectedFormProps<{}, AddStartProjectsModalProps>
> {
  UNSAFE_componentWillMount() {
    this.props.initialize({ startProjectsQuantity: 1 });
  }

  _onClose = () => {
    this.props.onModalClose();
  };

  render() {
    if (this.props.isLoading) {
      return <CustomLoader />;
    }
    return (
      <Modal dimmer="blurring" size="tiny" open={this.props.openModal} onClose={this._onClose}>
        <Modal.Header>Add Single Project</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Form onSubmit={this.props.handleSubmit} size="large">
              <Field
                component={NumberInput}
                name="startProjectsQuantity"
                label="Projects quantity"
                placeholder="Projects quantity"
                fluid
                defaultValue={1}
                icon="building outline"
                iconPosition="left"
                required
              />
              <Form.Button primary>Confirm</Form.Button>
            </Form>
            {this.props.formSubmitFailed ? (
              <Message negative>{this.props.formSubmitFailedMessage}</Message>
            ) : (
              <div />
            )}
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

const AddStartProjectsModalModal = reduxForm<{}, AddStartProjectsModalProps>({
  form: "AddStartProjects"
})(AddStartProjectsModal);

export default connect()(AddStartProjectsModalModal);
